import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { lighten, makeStyles } from '@material-ui/core/styles';

import { EngagementHistory } from 'api';

interface Props {
  item: EngagementHistory;
}

const useStyles = makeStyles(theme => ({
  button: {
    minWidth: 100,
    backgroundColor: lighten(theme.palette.primary.light, 0.2),
    color: theme.palette.primary.main,
    fontWeight: 800,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.main,
    },
  },
}));

const FollowConnectButton: FC<Props> = ({ item }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      fullWidth
      target="_blank"
      href={item.network_profile_url}
      className={classes.button}
      variant="contained"
      color="primary"
    >
      {t('components:viewProfile')}
    </Button>
  );
};

export default FollowConnectButton;
